/* eslint-disable react/prop-types */
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ConfirmationModal from "../Modal";
export const useModalAd = () => {
  const [showAdModal, setAdModaleVisibility] = React.useState(false);

  const onCloseAdModal = () => {
    setAdModaleVisibility(false);
  };
  const onShowAdModal = () => {
    setAdModaleVisibility(true);
  };
  return { showAdModal, onCloseAdModal, onShowAdModal };
};

export const ModalAvanzado = ({ showAdModal, onCloseAdModal }) => {
  const history = useHistory();
  return (
    <ConfirmationModal
      open={showAdModal}
      onClose={onCloseAdModal}
      onAccept={() => {
        history.push("/compra/firma-token");
      }}
      bodyContent={
        <React.Fragment>
          <span>
            Es requerido que el solicitante tenga su cédula vigente para obtener
            un certificado digital.
          </span>
          <br />
          <span style={{ marginTop: 2 }}>
            El proceso de enrolamiento es presencial en las oficinas de FIRMADOX
            o previa coordinación con el equipo de soporte.
          </span>
        </React.Fragment>
      }
    />
  );
};
